import { render, staticRenderFns } from "./DraftReviewOverlayV2026.vue?vue&type=template&id=8867a066&scoped=true"
import script from "./DraftReviewOverlayV2026.vue?vue&type=script&lang=js"
export * from "./DraftReviewOverlayV2026.vue?vue&type=script&lang=js"
import style0 from "./DraftReviewOverlayV2026.vue?vue&type=style&index=0&id=8867a066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8867a066",
  null
  
)

export default component.exports